import { getBylineAppContentPropertyKeys } from '@confluence/forge-ui/entry-points/bylineContentPropertyKeys.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import ByLineForgeAppGeneralContentPropertyQuery from './__generated__/ByLineForgeAppGeneralContentPropertyQuery.graphql.ts';

export const preloadBylineAppContentProperties = (contentId: string): Promise<unknown> => {
	const keys = getBylineAppContentPropertyKeys();
	if (keys.length === 0) {
		return Promise.resolve();
	}

	return query({
		query: ByLineForgeAppGeneralContentPropertyQuery,
		variables: { contentId, keys },
		errorPolicy: 'all',
	});
};
